<template>
  <span>
    <a class="ml-2 a-ativador" @click.prevent="openModal">Como funciona?</a>

    <transition name="fade">
      <div v-if="isOpen" class="im-backdrop" @click.self="closeModal">
        <div
          class="im-card"
          role="dialog"
          aria-modal="true"
          aria-labelledby="im-title"
        >
          <div class="im-icon" aria-hidden="true">
            <v-icon size="30" color="#39404B">$Info</v-icon>
          </div>

          <h2 class="im-title">Como funciona?</h2>

          <div class="im-body">
            <p>Você define uma Rodada de Compra com 2 períodos:</p>

            <ul>
              <li>Vendas a cobrir (base no histórico): período passado que representa as vendas que você quer cobrir.</li>
              <li>Compra: período futuro em que você vai comprar para cobrir essas vendas.</li>
            </ul>

            <p>Depois você pode aplicar uma influência geral e ajustes por item.</p>
          </div>

          <div class="im-close-cntr" @click="closeModal">
            <span class="im-close-btn">
              Fechar
            </span>
          </div>
        </div>
      </div>
    </transition>
  </span>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from "vue";

export default {
  name: "DialogComoFunciona",
  setup() {
    const isOpen = ref(false);

    const openModal = () => {
      isOpen.value = true;
    };

    const closeModal = () => {
      isOpen.value = false;
    };

    const onKeydown = (e) => {
      if (e.key === "Escape") closeModal();
    };

    watch(isOpen, (open) => {
      if (open) document.addEventListener("keydown", onKeydown);
      else document.removeEventListener("keydown", onKeydown);
    });

    onMounted(() => {
      if (isOpen.value) document.addEventListener("keydown", onKeydown);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("keydown", onKeydown);
    });

    return {
      isOpen,
      openModal,
      closeModal,
    };
  },
};
</script>

<style scoped>
.a-ativador {
  color: #F2A202;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #da9308;
  }
}

.im-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.im-card {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18);
  padding: 35px;
  text-align: center;
  position: relative;
}

.im-icon {
  display: flex;
  justify-content: center;
  margin-top: 4px;
  margin-bottom: 20px;
}

.im-title {
  margin: 0 0 24px;
  font-size: 18px;
  font-weight: 600;
  color: #39404B;
}

.im-body {
  text-align: left;
  color: #374151;
  font-size: 15px;
  margin-bottom: 10px;
}

.im-body p {
  margin: 0 0 10px;
}

.im-body ul {
  margin: 0 0 10px 18px;
  padding: 0;
}

.im-body li {
  margin-bottom: 8px;
}

.im-body strong {
  font-weight: 700;
  color: #111827;
}

.im-close-cntr {
  padding: 10px 8px;
  margin-top: 20px;
}

.im-close-btn {
  width: 100%;
  border: 0;
  color: #4075FF;
  font-weight: 400;
  font-size: 16px;
  padding: 10px 8px;
  margin-top: 20px;

  background: transparent;
  cursor: pointer;

  &:hover {
    color: #2262fb;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.16s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
